import React from 'react'
import { connect } from 'react-redux'

import { selectSpecialtyMapper } from '../selectors'

const SpecialtiesText = ({ specialties, categories }) => {
  const grouped = specialties.getCompactSubtrees(categories)
  return (
    <React.Fragment>
      {grouped.map((category, i) => (
        <span key={i}>
          <strong>
            {category.label + (category.children.length ? ': ' : '')}
          </strong>
          {category.children.map((category, i) => (
            <span key={i}>{(i > 0 ? ', ' : '') + category.label}</span>
          ))}
          {i < grouped.length - 1 ? '; ' : ''}
        </span>
      ))}
    </React.Fragment>
  )
}

export default connect(state => ({
  specialties: selectSpecialtyMapper(state),
}))(SpecialtiesText)
